import { render } from "./CliDOBVerificationTab.vue?vue&type=template&id=1f616c18&scoped=true&ts=true"
import script from "./CliDOBVerificationTab.vue?vue&type=script&lang=ts"
export * from "./CliDOBVerificationTab.vue?vue&type=script&lang=ts"

import "./CliDOBVerificationTab.vue?vue&type=style&index=0&id=1f616c18&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f616c18"]])

export default __exports__